import * as moment from "moment";
import { stringify } from "querystring";

export class DateUtil {

    /**
     * now
     */
    public static now(): Date {
        return new Date(Date.now())
    }

    /**
     * now in UTC string format
     */
    public static nowUtc(): string {
        const ret = new Date(Date.now()).toUTCString();
        return ret;
    }

    /**
     * 
     * @param a 
     * @param b 
     * @returns 
     */
    public static sort(a: Date, b: Date): number {
        return new Date(b).getTime() - new Date(a).getTime()
    }

    /**
     * 
     * @param numSeconds 
     * @returns 
     */
    public static seconds_to_hhmmss(numSeconds: number): string {
        if (Math.round(numSeconds) <= 60)
            return '00:00:' + (Math.round(numSeconds) < 10 ? '0' : '') + Math.round(numSeconds).toString();

        const mins_num = numSeconds / 60;

        let hours = Math.floor(mins_num / 60);
        let minutes = Math.floor((mins_num - ((hours * 3600)) / 60));
        let seconds = Math.floor((mins_num * 60) - (hours * 3600) - (minutes * 60));

        return (hours < 10 ? '0' : '') + hours.toString()
            + ':' + (minutes < 10 ? '0' : '') + minutes.toString()
            + ':' + (seconds < 10 ? '0' : '') + seconds.toString();
    }

    /**
     * 
     * @param start 
     * @param end 
     * @returns 
     */
    public static diffSeconds(start: Date, end: Date): number {
        if (!start || !end)
            return 0;

        const dif = new Date(end).getTime() - new Date(start).getTime();
        const seconds = dif / 1000;
        return Math.abs(seconds);
    }

    /**
     *
     * @param dt
     * @param months
     * @returns
     */
    public static AddMonths(dt: Date, months: number): Date {
        return new Date(dt.setMonth(dt.getMonth() + months));
    }

    /**
     *
     * @param dt
     * @param seconds
     * @returns
     */
    public static AddSeconds(dt: Date, seconds: number): Date {
        return new Date(dt.setSeconds(dt.getSeconds() + seconds));
    }


    /**
     * parse it
     */
    public static Parse(v: string): Date {
        const n: number = Date.parse(v);
        return new Date(n);
    }

    /**
     *
     * @param dt
     * @returns mm/dd/yyyy hh:mm AM / PM
     */
    public static shortDateTime(dt: Date): string {
        const d = new Date(dt);

        const ret = `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
        return ret;
    }

    /**
     *
     * @param dt
     * @returns mm/dd/yyyy hh:mm AM / PM
     */
    public static shortDateTimeLocal(dt: Date, includeTime: boolean = true): string {
        let dataStrg: string = dt.toString();
        dataStrg = dataStrg.length && dataStrg.slice(-1) == 'Z' ? dataStrg.slice(0, -1) : dataStrg;

        const d = new Date(dataStrg);

        const ret = includeTime ? `${d.toLocaleDateString()} ${d.toLocaleTimeString()}` : d.toLocaleDateString();
        return ret;
    }

    /**
     *
     * @param dt
     * @returns
     */
    public static shortDate(dt: Date): string {
        return new Date(dt).toLocaleDateString();
    }

    public static readonly MinDate: string = '1971-01-01';
    public static readonly MaxDate: string = '2071-01-01';

    /**
     * 
     * @param value 
     * @returns 
     */
    public static isoDateString(value: Date): string {
        if (!value)
            return undefined;

        const ret = (new Date(value).toISOString()).split('T')[0];
        return ret;
    }

    /**
     * 
     * @param value 
     * @param min 
     * @param max 
     * @returns 
     */
    public static validateString(value: string, min: string = undefined, max: string = undefined): boolean {
        if (!value)
            return false;

        const dateValue = Date.parse(value);
        if (!dateValue)
            return false;

        const dateMin = Date.parse((min ?? DateUtil.MinDate)) ?? Date.parse(DateUtil.MinDate);
        const dateMax = Date.parse((min ?? DateUtil.MaxDate)) ?? Date.parse(DateUtil.MaxDate);

        const ret = dateValue >= dateMin && dateValue <= dateMax;
        return ret;
    }

    /**
     * @param givenDate
     * @returns true || false
     */
    public static isDateInPast(givenDate: Date): boolean {
        return new Date(givenDate) < new Date(DateUtil.now()) ? true : false;
    }

    /**
     * 
     * @param timeStrg1 
     * @param timeStrg2 
     * @returns 
     */
    public static compareTimes(timeStrg1: string, timeStrg2: string): boolean {
        if ((timeStrg1 ?? '') === (timeStrg2 ?? '')) {
            return true;
        }
        var time1 = timeStrg1.split(':');
        var time2 = timeStrg2.split(':');
        if (time1.length < 2 || time2.length < 2)
            return false;

        var hour1 = Number(time1[0]);
        var hour2 = Number(time2[0]);
        var min1 = Number(time1[1]);
        var min2 = Number(time2[1]);

        if (isNaN(hour1) || isNaN(hour2) || isNaN(min1) || isNaN(min2))
            return false;
        if (hour1 > hour2) {
            return false;
        } else if (hour1 == hour2 && min1 > min2) {
            return false;
        }
        return true;
    }

    /**
     * 
     * @param time 
     * @returns 
     */
    public static to12HourTime(time: string): string {
        var t = time.split(':');

        if (t.length != 2)
            return time;
        var hour = Number(t[0]);
        var min = Number(t[1]);

        if (isNaN(hour) || isNaN(min))
            return time;

        return ('0' + (hour % 12 || 12)).slice(-2) + ':' + ("0" + min).slice(-2) + (hour < 12 ? ' AM' : ' PM');
    }

    /**
     * 
     * @param date 
     */
    public static stringToDate(date: string): Date {
        if ((date ?? '').length > 0) {
            return moment(date).toDate();
        }
        return undefined;
    }

    /**
     * 
     * @param compDate 
     * @param startDate 
     * @param endDate 
     * @returns 
     */
    public static isDateBetweenDates(compDate: Date, startDate: Date, endDate: Date): boolean {

        if (compDate < startDate || compDate > endDate)
            return false;
        return true;
    }

    public static getLastDayOfPreviousMonth(today: Date): Date {

        var firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        return new Date(firstDayOfCurrentMonth.getTime() - 1);

    }

    public static buildDateFromDateTimeString(dateStr: string, timeStr: string): Date {
        const normalizedDateStr = dateStr.replace(/[-.]/g, '/'); // Replace - or . with /
        const [month, day, year] = normalizedDateStr.split('/').map(Number);
        const [hour, minute] = timeStr.split(':').map(Number);

        return new Date(year, month - 1, day, hour, minute);
    }

    /**
     * 
     * @param startDate 
     * @param startTime 
     * @param endTime 
     * @returns return end date and if end time after midnigt will change to next date
     */
    public static getEndDateTime(startDate: string, startTime: string, endTime: string): Date {
        const start = this.buildDateFromDateTimeString(startDate, startTime);
        const end = this.buildDateFromDateTimeString(startDate, endTime);

        if (end <= start) {
            end.setDate(end.getDate() + 1); // Crossed midnight
        }

        return end;
    }

    /**
     * 
     * @param startDate 
     * @param endDate 
     * @returns To calculate duration in minutes between a start and end date + time 
     */
    public static getDurationInMinutes(startDate?: Date, endDate?: Date): number | null {
        if (!startDate || !endDate || isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
            return null;
        }

        const diffMs = endDate.getTime() - startDate.getTime();
        return Math.floor(diffMs / 60000); // convert to minutes
    }
}
